import React from 'react';
import { useIntl } from 'react-intl';
import CreateButton from '@/components/buttons/CreateButton';
import RemovableCohortFilterValue from './RemovableCohortFilterValue';
import CohortFilterValuesNumber from './CohortFilterValuesNumber';

const components = {
  integer: CohortFilterValuesNumber,
  decimal: CohortFilterValuesNumber,
};

const CohortFilterValuesArray = ({
  defaultValue,
  disabled,
  fieldType,
  filterUUID,
  onChange,
  saveErrors,
  values,
}) => {
  const intl = useIntl();
  const createValue = () => {
    const newValues = Array.isArray(values) ? [...values] : [];
    newValues.push(defaultValue);
    onChange(newValues);
  };

  const Component = components[fieldType];
  const editors = values.map((value, index) => (
    // eslint-disable-next-line react/jsx-key
    <Component
      filterUUID={filterUUID}
      saveErrors={saveErrors}
      values={values}
      value={value}
      fieldType={fieldType}
      index={index}
      disabled={disabled}
      onChange={onChange}
      placeholder={intl.formatMessage({ id: 'cohort.filter.array.placeholder' })}
    />
  ));

  const inputs = editors.length === 1 ? editors : editors.map((editor, index) => (
    // eslint-disable-next-line react/jsx-key
    <RemovableCohortFilterValue
      values={values}
      index={index}
      onChange={onChange}
    >
      {editor}
    </RemovableCohortFilterValue>
  ));

  inputs.push(<CreateButton
    key={`create_button_${filterUUID}`}
    entity="cohort.filter.value"
    onClick={createValue}
    className="aridhia-cohort-filter-array-add"
  />);

  return inputs;
};

export default CohortFilterValuesArray;
